'use strict';

$.fn.asyncLoad = function(callBack){
    return $(this).each(function () {
        var $this = $(this);
        var sectionInProgress = $this;

        if($this.data('load-url')) {
            sectionInProgress.addClass('in-progress relative');
            sectionInProgress.css('min-height', '100px');
            // Ajax query
            $.ajax({
                method: "GET",
                url: $this.data('load-url'),
                cache: false,
                data: {
                    tabletMobile: TINK.matchMediaMobileTablet()
                },
                success: function (data) {
                    // Replace content with ajax data
                    var $data = $(data);
                    $this.replaceWith($data);

                    // Callback if defined
                    if (callBack) {
                        callBack();
                    }
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            }).always(function() {
                sectionInProgress.css('min-height', '');
                $this.removeClass('in-progress relative');
            });
        }
    });
};

/*
 * The official debounce function from debounce-1.0.5.js breaks the asynchronous update mechanism when we have many item-addToCart element.
 * By using this simplified debounce implementation, it resolves the issue (JIRA : https://jira.bkom.com/browse/T3764-5806)
 *
 * @cdemers
 */
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function reloadPage() {
    // reload the page. usually use window.top.location.reload() but there is a bug with firefox
    // use this syntax until firefox bug is fixed
    // remove anchor '#...' else it won't reload the page
    let currentUrl = window.location.href;
    if (currentUrl.indexOf('storeId') !== -1) {
        currentUrl = TINK.removeParamFromUrl('storeId', window.location.href);
    }

    let urlWithoutHash = currentUrl.replace(location.hash, "");
    window.top.location.href = urlWithoutHash;

    // Force reload when URL ends with # without anchor (ex: www.metro.ca/en#). Browser prevented reload when only removing hash.
    if (urlWithoutHash === currentUrl.replace(location.hash, "")) {
        window.top.location.reload();
    }
}

function stopSpinnersWhenNoCartEntryProvided() {
    if (window['cartItem'] === null) {
        TINK.stopProgress($('.in-progress.relative'));
        $(':focus').blur();
    }
}

function isInCheckoutPage(excludeCartPage) {
    return excludeCartPage ? typeof checkoutStep !== 'undefined' && checkoutStep > 0 : typeof checkoutStep !== 'undefined';
}
